export default {
	text:
		'Ваш браузер устарел или не поддерживается.\nНекоторые функции сайта могут работать не корректно',
	btn: 'Начать использование',
}
